import React from 'react';
import { PRICE } from './salesData';
interface PriceBlockProps {
  className?: string;
  size?: 'md' | 'lg';
}

/**
 * Único bloque de precio de la landing. Tipografía sans serif en todos los
 * niveles: precio anterior pequeño, gris cálido y tachado; precio vigente en
 * bold dominante; "Pago único" como microcopy.
 */
export function PriceBlock({
  className = '',
  size = 'md'
}: PriceBlockProps) {
  const current = size === 'lg' ? 'text-[2.6rem] sm:text-5xl' : 'text-[2.25rem] sm:text-[2.75rem]';
  return <div className={`flex flex-col items-center ${className}`} data-id="element-311" data-mp="1g5v8iylir7po">
      <p className="font-sans text-sm font-normal tabular-nums text-charcoal/45 sm:text-base" style={{
      textDecoration: 'line-through'
    }} data-id="element-312" data-mp="1tw8gv22boofj">
        {PRICE.previous}
      </p>
      <p className={`mt-0.5 font-sans font-bold leading-none tracking-tight tabular-nums text-charcoal ${current}`} data-id="element-313" data-mp="11fxrr3px5kai">
        {PRICE.current}
      </p>
      <p className="mt-2 font-sans text-[0.68rem] font-medium uppercase tracking-[0.18em] text-charcoal/55" data-id="element-314" data-mp="wgkt7lpoqos3">
        {PRICE.note}
      </p>
    </div>;
}